<template>
  <div class="tw-flex tw-flex-wrap tw-justify-center tw-items-center">
    <div class="tw-flex tw-basis-4/12 md:tw-basis-3/12 lg:tw-basis-2/12 tw-items-center tw-p-1 sm:tw-p-2 md:tw-p-3"
      v-for="image in partners">
      <a :href="image.href" target="_blank" class="tw-flex tw-justify-center tw-px-1" v-if="image">
        <NuxtImg :src="image.image" :alt="image.name" :title="image.name" class="tw-w-full" />
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>

const partners = [
  // {
  //   name: 'Circle',
  //   href: 'https://www.circle.com/',
  //   image: `/res/logo-partners/Exchanges Wallets/Circle.png`,
  // },
  {
    name: 'Kucoin',
    href: 'https://www.kucoin.com/',
    image: `/res/logo-partners/Exchanges Wallets/Kucoin.png`,
  },
  {
    name: 'Bitget',
    href: 'https://www.bitget.com/',
    image: `/res/logo-partners/Exchanges Wallets/Bitget.png`,
  },
  {
    name: 'Phemex',
    href: 'https://phemex.com/',
    image: `/res/logo-partners/Exchanges Wallets/Phemex.png`,
  },
  {
    name: 'Bitrue',
    href: 'https://bitrue.com/',
    image: `/res/logo-partners/Exchanges Wallets/Bitrue.png`,
  },
  {
    name: 'LBANK',
    href: 'https://www.lbank.info/',
    image: `/res/logo-partners/Exchanges Wallets/LBANK.png`,
  },
  {
    name: 'BitMart',
    href: 'https://www.bitmart.com/',
    image: `/res/logo-partners/Exchanges Wallets/BitMart.png`,
  },
  {
    name: 'Cobo Wallet',
    href: 'https://cobo.com/',
    image: `/res/logo-partners/Exchanges Wallets/Cobo Wallet.png`,
  },
  {
    name: 'BingX',
    href: 'https://bingx.com/en-us',
    image: `/res/logo-partners/Exchanges Wallets/BingX.png`,
  },
  {
    name: 'Bitunix',
    href: 'https://www.bitunix.com/',
    image: `/res/logo-partners/Exchanges Wallets/Bitunix.png`,
  },
  // {
  //   name: 'Xbank',
  //   href: 'https://xbank.plus/',
  //   image: `/res/logo-partners/Exchanges Wallets/Xbank.png`,
  // },
  {
    name: 'XT',
    href: 'https://www.xt.com/',
    image: `/res/logo-partners/Exchanges Wallets/XT.png`,
  },
  {
    name: 'BYDFI',
    href: 'https://www.bydfi.com/en',
    image: `/res/logo-partners/Exchanges Wallets/BYDFI.png`,
  },
  // {
  //   name: 'ZB',
  //   href: 'https://www.zb.com/',
  //   image: `/res/logo-partners/Exchanges Wallets/ZB.png`,
  // },
  {
    name: 'Mexc',
    href: 'https://www.mexc.com/',
    image: `/res/logo-partners/Exchanges Wallets/Mexc.png`,
  },
  {
    name: 'Mexo',
    href: 'https://www.mexo.io/',
    image: `/res/logo-partners/Exchanges Wallets/Mexo.png`,
  },
  {
    name: 'TokenPocket',
    href: 'https://www.tokenpocket.pro/en',
    image: `/res/logo-partners/Exchanges Wallets/TokenPocket.png`,
  },
  {
    name: 'Tbitex',
    href: 'https://www.tbitex.com/',
    image: `/res/logo-partners/Exchanges Wallets/Tbitex.png`,
  },
  {
    name: 'Valens Exchange',
    href: 'https://valens-exchange.com/',
    image: `/res/logo-partners/Exchanges Wallets/Valens Exchange.png`,
  },
  {
    name: 'dtcpay',
    href: 'https://www.dtcpay.com/',
    image: `/res/logo-partners/Exchanges Wallets/dtcpay.png`,
  },
  {
    name: 'FomoPay',
    href: 'https://www.fomopay.com/',
    image: `/res/logo-partners/Exchanges Wallets/FomoPay.png`,
  },
  {
    name: 'Ellipal',
    href: 'https://www.ellipal.com/',
    image: `/res/logo-partners/Exchanges Wallets/Ellipal.png`,
  },
  {
    name: 'coinw',
    href: 'https://www.coinw.com/',
    image: `/res/logo-partners/Exchanges Wallets/CoinW.png`,
  },
  {
    name: 'ProBit',
    href: 'https://www.probit.com/en-us/',
    image: `/res/logo-partners/Exchanges Wallets/ProBit.png`,
  },
  {
    name: 'babylon',
    href: 'https://www.babylon.com/',
    image: `/res/logo-partners/Exchanges Wallets/babylon.png`,
  },
  {
    name: 'DoraHacks',
    href: 'https://dorahacks.com/',
    image: `/res/logo-partners/Blockchain DeFi/DoraHacks.png`,
  },
  {
    name: 'IOTEX',
    href: 'https://iotex.io/',
    image: `/res/logo-partners/Blockchain DeFi/IOTEX.png`,
  },
  {
    name: 'SWFT Coin',
    href: 'https://www.swft.pro/',
    image: `/res/logo-partners/Blockchain DeFi/SWFT Coin.png`,
  },
  {
    name: 'Dforce',
    href: 'https://dforce.network/',
    image: `/res/logo-partners/Blockchain DeFi/Dforce.png`,
  },
  {
    name: 'VeChain',
    href: 'https://www.vechain.com/',
    image: `/res/logo-partners/Blockchain DeFi/VeChain.png`,
  },
  // {
  //   name: 'Poolin',
  //   href: 'https://www.poolin.com/',
  //   image: `/res/logo-partners/Blockchain DeFi/Poolin.png`,
  // },
  {
    name: 'hkbitex',
    href: 'https://www.hkbitex.com.hk/',
    image: `/res/logo-partners/Blockchain DeFi/hkbitex.png`,
  },
  {
    name: 'woox',
    href: 'https://www.woox.com/',
    image: `/res/logo-partners/Exchanges Wallets/woox.png`,
  },
  {
    name: 'KryptoGo',
    href: 'https://www.kryptogo.com/',
    image: `/res/logo-partners/Exchanges Wallets/KryptoGo.png`,
  },
  {
    name: 'CyberX',
    herf: "https://www.cyberx.com/",
    image: `/res/logo-partners/Exchanges Wallets/CyberX.png`,
  },
  {
    name: 'Galxe',
    href: "https://www.galxe.com/",
    image: `/res/logo-partners/Exchanges Wallets/Galxe.png`,
  },
  {
    name: 'IOSG',
    href: "https://iosg.vc/",
    image: `/res/logo-partners/Exchanges Wallets/IOSG.png`,
  },
  {
    name: 'QBIT',
    href: "https://www.qbitnetwork.com/",
    image: `/res/logo-partners/Exchanges Wallets/QBIT.png`,
  },
  // {
  //   name: 'StoneX',
  //   href: "https://www.stonex.com/en/",
  //   image: `/res/logo-partners/Exchanges Wallets/StoneX.png`,
  // },
]



// const items = [
//   ['ByBit', 'https://www.bybit.com/', 'Exchanges Wallets'],
//   ['Kucoin', 'https://www.kucoin.com/', 'Exchanges Wallets'],
//   // ['Gate', 'https://www.gate.io/en/', 'Exchanges Wallets'],
//   ['Cobo Wallet', 'https://cobo.com/', 'Exchanges Wallets'],
//   ['CyberX', 'https://www.cyberx.com', 'Brokers Institutions'],
//   // ["Deribit", "https://www.deribit.com/", "Exchanges Wallets"],
//   ['Bitrue', 'https://www.bitrue.com/', 'Exchanges Wallets'],
//   ['BitMart', 'https://www.bitmart.com/', 'Exchanges Wallets'],
//   ['TokenPocket', 'https://www.tokenpocket.pro/', 'Exchanges Wallets'],
//   // ['Poolin', 'https://www.poolin.com/', 'Blockchain DeFi'],
//   ['hkbitex', 'https://www.hkbitex.com.hk/', 'Blockchain DeFi'],
//   ['VeChain', 'https://www.vechain.com/', 'Blockchain DeFi'],
//   ['IOTEX', 'https://iotex.io/', 'Blockchain DeFi'],
// ].map((item) => {
//   return {
//     name: item[0],
//     href: item[1],
//     image: `/res/logo-partners/${item[2]}/${item[0]}.png`,
//   }
// })
</script>
